import { memo } from 'react'
import { Link } from 'react-router-dom'

import { ExternalLinkIcon, SuccessIcon } from '../../../../components/Icons'
import { ShareButtons } from '../../../../components/ShareButtons'
import { useMediaQueryContext } from '../../../../contexts/MediaQueryContext'

interface PublishedSuccessStateProps {
  twinId: string
  personaSlug: string
  isMacos: boolean
}

const PublishedSuccessState: React.FC<PublishedSuccessStateProps> = memo(
  ({ twinId, personaSlug, isMacos }) => {
    const { isSm } = useMediaQueryContext()

    return (
      <div className="h-full relative grow flex flex-col items-center justify-center px-0 sm:px-4 pt-4 sm:pt-10">
        <SuccessIcon size={isSm ? 76 : 118} className="text-white" />

        <h2 className="text-[24px] sm:text-[40px] mt-4 sm:mt-8 text-center font-seriftext">
          Congratulations, Your Digital Twin is
          <b> Published!</b>
        </h2>

        <Link
          data-testid="published-success-talk-with-twin-link"
          className="btn btn-primary mt-8"
          to={
            isMacos
              ? `napster-companion://companion/start/${twinId}`
              : `/${personaSlug}?start=true`
          }
        >
          Talk With Your Twin&nbsp;
          <ExternalLinkIcon size={16} />
        </Link>

        <h3 className="text-xl mt-8">Share Your Twin</h3>
        <p className="text-center max-w-[600px] mx-auto">
          Share a link so people can meet your AI twin. It answers in your voice
          within the topics you choose. You can turn sharing off anytime.
        </p>

        <div className="mt-4">
          <ShareButtons slug={personaSlug} />
        </div>
      </div>
    )
  },
)

export { PublishedSuccessState }
